import { Autocomplete, Button, Chip, TextField } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { ActiveAlarmsData } from "../../Alarms/ActiveAlarms";
import { useImmer } from "use-immer";
import { APP_BASE_URL, GET_DEVICE_TYPE_ASSET } from "../../../Common/EndPoints";
import axios from "axios";
import "./AssetsFilters.scss";
import { AutocompleteStationListPop } from "../../AutocompleteStationListPop/AutocompleteStationListPop";
import { useSelector } from "react-redux";
import { selectedCustomersSelector } from "../../../features/authentication/auth-slice";
import { getParsedLocalStorage } from "../../../Utils/storage-utils";
import { useSearchParams } from "react-router-dom";
import { extractParsedDataFromPermissions } from "../../../Utils/Utils";
import { systemConfigurationApi } from "../../../features/api/system/system.service";

const { useGetSystemConfigurationQuery } = systemConfigurationApi
const initialFilters = {
  zone_ids: [],
  div_ids: [],
  customer_ids: [],
  deviceTypeIds: [],
  systems: [],
  makeContains: "",
  nameContains: "",
};

const getStrIdListFromOptions = (dd = []) => {
  return dd.map((obj) => obj.id).join(",");
};

function AssetsFilters({ getAssetFilter }) {
  const user_permissions = getParsedLocalStorage("permissions");
  const parsedPermissions = useMemo(() => {
    return extractParsedDataFromPermissions(user_permissions);
  }, []);

  const selectedCustomersList = useSelector(selectedCustomersSelector);
  const permittedCustomerIds = useMemo(() => {
    const _list = selectedCustomersList;
    if (!_list) return [];
    return _list.map((customer) => ({ id: customer.customerId, value: customer.customerName }));
  }, [selectedCustomersList]);
  // const selectedCustomers = useSelector(selectedCustomersSelector);
  // const permittedCustomerIds = useMemo(() => {
  //   const _list = selectedCustomers;
  //   if (!_list) return [];
  //   return _list.map((customer) => ({ id: customer.customerId, value: customer.customerName }));
  // }, [selectedCustomers]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [deviceTypeList, setDeviceTypeList] = useState([]);

  const queryFilter = {
    customer_ids:
      searchParams
        .get("station")
        ?.split(",")
        ?.map((val) => {
          return permittedCustomerIds.find((customer) => customer.value?.toLowerCase() === val?.toLowerCase?.());
        })
        ?.map((val) => ({ id: val.id, value: val.value })) ?? [],
    deviceTypeIds:
      searchParams
        .get("deviceType")
        ?.split(",")
        ?.map((val) => {
          return deviceTypeList.find((deviceType) => deviceType.value === val)?.value;
        })
        .filter((val) => val) ?? [],
    isMaintenanceStarted: searchParams.get("maintenanceStatus") === "true" ? true : null,
  };

  const [filters, setFilters] = useImmer({
    ...initialFilters,
    ...queryFilter,
  });


  const zone_dd = useMemo(() => {
    return parsedPermissions.zones;
  }, []);

  const div_dd = useMemo(() => {
    let total_divs = parsedPermissions.divisions;
    if (filters.zone_ids.length) {
      const ids = filters.zone_ids.map((obj) => obj.id);
      total_divs = parsedPermissions.divisions.filter((div_obj) => ids.includes(div_obj.zone.id));
      const filtered_form_div_ids = filters.div_ids.filter((selected_div_obj) => {
        return total_divs.find((obj) => obj.id === selected_div_obj.id);
      });
      setFilters((prev) => {
        prev.div_ids = filtered_form_div_ids;
      });
    }

    return total_divs;
  }, [filters.zone_ids]);

  const customer_dd = useMemo(() => {
    let filtered_stations = parsedPermissions.stations.filter((obj) => permittedCustomerIds.find((customer) => customer.id === obj.id));
    if (filters.div_ids.length) {
      const selected_div_ids = filters.div_ids.map((obj) => obj.id);
      filtered_stations = filtered_stations.filter((stationObj) => selected_div_ids.includes(stationObj.division.id));
    } else if (filters.zone_ids.length) {
      const selected_zone_ids = filters.zone_ids.map((obj) => obj.id);
      filtered_stations = filtered_stations.filter((stationObj) => selected_zone_ids.includes(stationObj.zone.id));
    }
    const filtered_form_stn_ids = filters.customer_ids.filter((selected_stn_obj) => {
      return filtered_stations.find((obj) => obj.id === selected_stn_obj.id);
    });
    setFilters((prev) => {
      prev.customer_ids = filtered_form_stn_ids;
    });
    return filtered_stations;
  }, [permittedCustomerIds, filters.div_ids, filters.zone_ids]);

  useEffect(() => {
    setFilters((state) => {
      state.deviceTypeIds = queryFilter.deviceTypeIds;
    });
    getAssetFilter({
      ...filters,
      deviceTypeIds: queryFilter.deviceTypeIds,
    });
  }, [deviceTypeList]);

  const { data: systems = [] } = useGetSystemConfigurationQuery();

  const system_options = useMemo(() => {
    return systems.map((system) => ({
      id: system.id,
      label: system.code,
    }));
  }, [systems]);

  useEffect(() => {
    getDeviceTypes();
  }, []);
  // useEffect(() => {
  //   setFilters((state) => {
  //     state.customerIds = state.customerIds.filter((customer) => customerIdList.includes(customer.id)).map((customer) => customer.id);
  //   });
  // }, [customerIdList]);
  const handleChange = (value, stateName) => {
    setSearchParams({});
    setFilters((prev) => {
      prev[stateName] = value;
    });
  };
  const getDeviceTypes = () => {
    let url = `${APP_BASE_URL}${GET_DEVICE_TYPE_ASSET}`;
    axios.get(url).then((res) => {
      let deviceTypes = res.data.data.map((type) => {
        return {
          value: type.typeid,
          label: type.type,
          alias: type.label,
        };
      });
      setDeviceTypeList(deviceTypes);
      //   setDropDowns((prev) => {
      //     prev.deviceTypeDD = deviceTypes;
      //   });
    });
  };

  const onFilter = (filterParams) => {
    let newFilterParams = {
      ...filterParams,
      customerIds: (filters.customer_ids && filters.customer_ids.length) ? getStrIdListFromOptions(filters.customer_ids) : getStrIdListFromOptions(customer_dd),
      deviceTypeIds: filterParams.deviceTypeIds,
      systems: (filterParams?.systems || []).map((val) => val.id),
    };
    getAssetFilter(newFilterParams);
  };

  useEffect(() => {
    onFilter({
      ...initialFilters,
      ...queryFilter,
    })
  }, [searchParams, deviceTypeList]);
  return (
    <div className="assets-tableFilter">
      {/* <Autocomplete
        size="small"
        className="filter-input auto-complete"
        multiple
        disableCloseOnSelect
        options={permittedCustomerIds}
        renderInput={(params) => (
          <TextField className="filter-input" size="small" {...params} label="Station" placeholder="Station" />
        )}
        getOptionLabel={(customer) => customer.value}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={permittedCustomerIds.filter((val) => filters.customerIds.includes(val.id)) ?? []}
        onChange={(_, newValue) => {
          handleChange(
            newValue.map((val) => val.id),
            "customerIds",
          );
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((stn) => stn?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      /> */}

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        multiple
        options={zone_dd ?? []}
        value={filters.zone_ids || []}
        onChange={(_, newValue) => {
          handleChange(
            newValue,
            "zone_ids",
          );
        }}
        disableCloseOnSelect
        getOptionLabel={(opt) => opt.value}
        renderInput={(params) => <TextField {...params} label="Zones" />}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />
      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        multiple
        disableCloseOnSelect
        options={div_dd ?? []}
        value={filters.div_ids || []}
        onChange={(_, newValue) => {
          handleChange(
            newValue,
            "div_ids",
          );
        }}
        getOptionLabel={(opt) => opt.value}
        renderInput={(params) => <TextField {...params} label="Divisions" />}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />
      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        multiple
        disableCloseOnSelect
        options={customer_dd ?? []}
        value={filters.customer_ids || []}
        onChange={(_, newValue) => {
          handleChange(
            newValue,
            "customer_ids",
          );
        }}
        getOptionLabel={(opt) => opt.value}
        renderInput={(params) => <TextField {...params} label="Stations" />}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />

      <Autocomplete
        size="small"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        multiple
        className="filter-input"
        options={system_options}
        value={filters.systems || []}
        onChange={(_, newValue) => {
          handleChange(newValue, "systems");
        }}
        disableCloseOnSelect
        renderInput={(params) => <TextField {...params} label="Systems" />}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].label} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((stn) => stn?.label ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />
      {/* <Autocomplete
        size="small"
        isOptionEqualToValue={(option, value) => option === value}
        className="filter-input"
        options={['true', 'false']}
        value={filters.isMaintenanceStarted}
        onChange={(_, newValue) => {
          handleChange(newValue, "isMaintenanceStarted");
        }}
        renderInput={(params) => <TextField {...params} label="Maintenance Status" />}
      /> */}
      <Autocomplete
        className="filter-input"
        size="small"
        disablePortal
        id="combo-box-demo"
        value={deviceTypeList.filter((val) => filters.deviceTypeIds.includes(val.value)) ?? []}
        options={deviceTypeList}
        getOptionLabel={(params) => params.alias}
        onChange={(_, newValue) => {
          handleChange(
            newValue.map((val) => val.value),
            "deviceTypeIds",
          );
        }}
        disableCloseOnSelect
        // sx={{ width: 300 }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].label} {...getTagProps({ index: 0 })} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((stn) => stn?.label ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
        renderInput={(params) => <TextField size="small" {...params} label="Asset Type" />}
        multiple
      />
      <TextField
        className="filter-input"
        type="text"
        size="small"
        label="Make"
        value={filters.makeContains}
        onChange={(e) => {
          handleChange(e.target.value, "makeContains");
        }}
      />
      <TextField
        className="filter-input"
        type="text"
        size="small"
        label="Name"
        value={filters.nameContains}
        onChange={(e) => {
          handleChange(e.target.value?.toUpperCase(), "nameContains");
        }}
      />
      <Button variant="contained" onClick={() => onFilter(filters)}>
        Filter
      </Button>
      <Button
        variant="outlined"
        onClick={() => {
          onFilter(initialFilters);
          setFilters(initialFilters);
        }}
      >
        Clear
      </Button>
    </div>
  );
}

export default AssetsFilters;
